import axios from 'axios';

export default {
    getContext() {
        return axios.get(window.API_COMMON_BASE + '/context');
    }
}